import React, { Component } from 'react';
import { post } from "../../utility/apiClient";

import { connect } from 'react-redux';
import { updateRemainingTime, resetRemainingTime } from '../../redux/actions/sessionTimeoutActions';
import { showMessageBox } from '../../redux/actions/messageBoxActions';
import { hideLoadingScreen } from '../../redux/actions/loadingScreenActions';
import { resetPromoCodeData } from '../../redux/actions/promoCodeAction';

var _SessionTime = 20 * 60; // in seconds
var _WarningWillComeOn = 18 * 60; // in seconds


/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {
        RemainingTime: state.sessionTimeout.RemainingTime,
        PromoCode: state.promoCodeReducer,
        userDetails: state.userDetails
    }
};

/*-- Map the redux actions to props --*/
const mapDispatchToProps = {
    updateRemainingTime,
    resetRemainingTime,
    showMessageBox,
    hideLoadingScreen,
    resetPromoCodeData
};

class SessionTimeOutHandler extends Component {

    state = { isIgnoreSessionWarning: false, }

    componentDidMount() {
        this.StartTimer();
    };

    StartTimer() {
        this.CheckSession();
        this.props.resetRemainingTime();
        var countDown = setInterval(() => {
            if (this.props.RemainingTime >= Number(_SessionTime)) {
                this.promoCodeRollback();

                clearTimeout(countDown);
                this.props.hideLoadingScreen();
                window.sessionStorage.clear();
                let messageBox = {
                    show: true,
                    title: "Your session expired!",
                    className: "warning",
                    content: "Sorry, your session has expired.",
                    isConfirmation: false,
                    callBackFunction: () => { window.location.href = "/welcome"; }
                }
                this.props.showMessageBox(messageBox);
                this.setState({ isSessionValid: false });
            }
            else if ((this.props.RemainingTime) >= Number(_WarningWillComeOn) && (!this.state.isIgnoreSessionWarning)) {
                let messageBox = {
                    show: true,
                    title: `Your session will expire in ${Number(_SessionTime) - this.props.RemainingTime} seconds.!!!`,
                    className: "warning",
                    content: `Do you want more time?`,
                    isConfirmation: true,
                    callBackFunction: (response) => {
                        if (response === true) {
                            clearTimeout(countDown);
                            this.setState({ messageBox: { show: false } });
                            this.StartTimer();
                        }
                        else { this.setState({ isIgnoreSessionWarning: true }) }
                    }
                }
                this.props.showMessageBox(messageBox);
            }
            this.props.updateRemainingTime();
        }, 1000);
    };

    CheckSession() {
        post("/Common/CheckSession")
            .then(response => {
                if (response.status === 401) {
                    this.props.hideLoadingScreen();
                    this.setState({ isSessionValid: false });
                }
            });
    };

    promoCodeRollback() {
        if (!this.props.PromoCode.promoCodeFormat !== null && this.props.PromoCode.promoCodeFormat.length != 0) {

            let formData = {
                promoCodeFormat: this.props.PromoCode.promoCodeFormat,
                promoCodeRollback: true,
                PromoCodeCustomerID: this.props.userDetails.customerID
            };

            post("/Web/RollbackPromoCode", formData).then(response => {
                if (response.status == 200) {
                    this.props.resetPromoCodeData();
                }
            })
        }
    };

    render() {
        return (
            <div />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SessionTimeOutHandler);